import { callZigzagFunction } from '../../callZigzagFunction';

// flush user activity log
// 현재 전송이 지연되어 있는 로그들을 즉시 전송
export const fual = () => {
  callZigzagFunction('fual')();
};
